import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';
import { toast } from 'react-toastify';
import { useBusinessLogin } from '../../../hooks/auth/useBusinessLogin';
import './StoreForm.css';

// ایمپورت کامپوننت‌های فرزند
import InstagramConnect from './components/InstagramConnect';
import StoreInfo from './components/StoreInfo';
import StoreTheme from './components/StoreTheme';
import PaymentGateway from './components/PaymentGateway';
import ShippingMethods from './components/ShippingMethods';

function StoreForm({ is_toolbar_hidden = false }) {
    const [menuChoice, setMenuChoice] = useState(1);

    const businessDataHook = useBusinessLogin();
    const { login, data: initialBusinessData, businessId } = businessDataHook;

    const [localBusinessData, setLocalBusinessData] = useState(null);

    useEffect(() => {
        if (initialBusinessData) {
            setLocalBusinessData(initialBusinessData);
        }
    }, [initialBusinessData]);

    // 🎧 گوش دادن به ایونت به‌روزرسانی اطلاعات فروشگاه
    useEffect(() => {
        const handleBusinessUpdate = (e) => {
            const updatedInfo = e.detail;
            if (!updatedInfo) return;
            
            setLocalBusinessData((prev) => ({
                ...(prev || {}),
                ...updatedInfo,
                businessStatus_id: updatedInfo.businessStatus_id || 19
            }));
        };

        window.addEventListener('businessInfoUpdated', handleBusinessUpdate);
        return () => {
            window.removeEventListener('businessInfoUpdated', handleBusinessUpdate);
        };
    }, []);

    const menu = [
        {
            id: 1,
            title: "مشخصات",
            iconInactive: "/images/ConfigurationMenu/icons8-store-50.png",
            iconActive: "/images/ConfigurationMenu/icons8-shop-94.png",
            lineColor: "#4CAF50"
        },
        {
            id: 2,
            title: "قالب",
            iconInactive: "/images/ConfigurationMenu/icons8-paint-palette-50.png",
            iconActive: "/images/ConfigurationMenu/icons8-paint-palette-94.png",
            lineColor: "#FFC107"
        },
        {
            id: 3,
            title: "احراز اینستاگرام",
            iconInactive: "/images/ConfigurationMenu/icons8-instagram-logo-50 (1).png",
            iconActive: "/images/ConfigurationMenu/icons8-instagram-logo-94.png",
            lineColor: "#E1306C"
        },
        {
            id: 4,
            title: "درگاه و کارت ها",
            iconInactive: "/images/ConfigurationMenu/icons8-bank-cards-50.png",
            iconActive: "/images/ConfigurationMenu/icons8-cards-53.png",
            lineColor: "#2196F3"
        },
        {
            id: 5,
            title: "شیوه ارسال",
            iconInactive: "/images/ConfigurationMenu/icons8-delivery-50.png",
            iconActive: "/images/ConfigurationMenu/icons8-delivery-94.png",
            lineColor: "#1976D2"
        },
    ];

    const currentData = localBusinessData || initialBusinessData;

    // بررسی فعال بودن منوهای پیکربندی بر اساس ثبت مشخصات و دسته‌بندی
    const isStoreConfigured = Boolean(
        currentData?.title && (currentData?.category?.id || currentData?.category_id)
    );

    const liveBusinessHook = {
        ...businessDataHook,
        data: currentData
    };

    return (
        <div className={`store-form ${is_toolbar_hidden ? 'with-topbar-spacing' : ''}`} dir="rtl">

            {!login && (
                <div className="store-form-loading-container">
                    <ReactLoading
                        type={"spin"}
                        color={"var(--tg-theme-button-color, #2481cc)"}
                        height={40}
                        width={40}
                    />
                    <span className="store-form-loading-text">در حال بارگذاری اطلاعات...</span>
                </div>
            )}

            {login && (
                <>
                    {/* بخش منو */}
                    <div className="store-form-menu-container">
                        <div className="store-form-buttons">
                            {menu.map((item) => {
                                const isActive = item.id === menuChoice;
                                const isLocked = item.id !== 1 && !isStoreConfigured;

                                return (
                                    <div
                                        key={item.id}
                                        className={`menu-item ${isActive ? "active" : ""} ${isLocked ? "locked" : ""}`}
                                        onClick={() => {
                                            if (isLocked) {
                                                toast.warning("ابتدا «مشخصات فروشگاه» را تکمیل و ثبت کنید.", {
                                                    position: "top-right",
                                                    autoClose: 2500,
                                                    theme: "light",
                                                    rtl: true
                                                });
                                                return;
                                            }
                                            setMenuChoice(item.id);
                                        }}
                                        style={{ 
                                            opacity: isLocked ? 0.4 : 1, 
                                            cursor: isLocked ? 'not-allowed' : 'pointer',
                                            filter: isLocked ? 'grayscale(100%)' : 'none'
                                        }}
                                    >
                                        <div className="menu-icon">
                                            <img
                                                src={isActive ? item.iconActive : item.iconInactive}
                                                alt={item.title}
                                                style={{
                                                    width: '28px',
                                                    height: '28px',
                                                    objectFit: 'contain',
                                                    transform: isActive ? 'scale(1.12)' : 'scale(1)',
                                                    transition: 'transform 0.2s ease'
                                                }}
                                            />
                                        </div>

                                        <span className="menu-text">{item.title}</span>
                                        {isActive && (
                                            <div
                                                className="active-indicator"
                                                style={{ backgroundColor: item.lineColor }}
                                            />
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {/* بخش بدنه */}
                    <div className="store-form-body">
                        {menuChoice === 1 && (
                            <StoreInfo businessHook={liveBusinessHook} />
                        )}
                        {menuChoice === 2 && (
                            <StoreTheme businessHook={liveBusinessHook} />
                        )}
                        {menuChoice === 3 && (
                            <InstagramConnect
                                businessData={currentData}
                                businessId={businessId}
                            />
                        )}
                        {menuChoice === 4 && (
                            <PaymentGateway businessHook={liveBusinessHook} />
                        )}
                        {menuChoice === 5 && (
                            <ShippingMethods businessHook={liveBusinessHook} />
                        )}
                    </div>
                </>
            )}
        </div>
    );
}

export default StoreForm;
